import React from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim"; 
import { useCallback, useMemo } from "react";

const ParticlesComponent = (props) => {
  const options = useMemo(() => {
    return {
      background: {
        color: 'white', 
      },
      fullScreen: {
        enable: false, 
      },

      interactivity: {
        events: {
          onClick: {
            enable: true, 
            mode: "push", 
          },
          onHover: {
            enable: true, 
            mode: "repulse", 
          },
        },
        modes: {
          push: {
            quantity: 2, 
          },
          repulse: {
            distance: 150, 
          },
        },
      },
      particles: {
        color:{
            value:'#0b3599',
        },
        links: {
          enable: true, 
          distance: 200, 
          color:{
            value:'#D3D9E8',
            },
        },
        move: {
          enable: true, 
          speed: { min: 0.5, max: 3 }, 
        },
        opacity: {
          value: { min: 0.3, max: 0.7 }, 
        },
        size: {
          value: { min: 1, max: 3 }, 
        },
      },
    };
  }, []);

  const particlesInit = useCallback((engine) => {
    loadSlim(engine);
  }, []);

  return <Particles className='particles' id={props.id} init={particlesInit} options={options} />;
};

export default ParticlesComponent;
